import lineIndexMixins from '@/pages/index2.0/mixins/lineIndexMixins.js';
import app from '@/common/public.js';
import mdate from '@/common/momentHandle.js';
import dayjs from 'dayjs';
import { get } from 'lodash';

let checkEnterHotelWriteMinxins = {
  mixins: [lineIndexMixins],
  data() {
    return {};
  },
  methods: {
    // 验证有效，进入填单页需要处理的逻辑
    checkHotelEnterWritePage(item, isUseCacheDate) {
      // 1.5处去填单页的清空
      let settings = app.GetSettings();
      settings.hotelSelPassengerList = [];
      settings.applyData = [];
      settings.TravelImgList = [];
      settings.costCenter = {};

      // 填单页数据存储
      let HotelWriteOrderParmer = {};
      let systemTime = mdate.getCurrentTime();
      let today = dayjs(systemTime).format('YYYY-MM-DD');
      // 是否使用缓存日期
      let ArrivalDate = '';
      let DepartureDate = '';
      if (isUseCacheDate) {
        let { Date = [] } = get(settings, 'HotelSearchData', {});
        if (Date.length) {
          // 例如 页面缓存日期  6-20  6-25, 当天是27
          ArrivalDate = dayjs(Date[0]).isBefore(today) ? today : Date[0];
          DepartureDate =
            ArrivalDate === Date[1] || dayjs(Date[1]).isBefore(ArrivalDate)
              ? dayjs(ArrivalDate).add(1, 'day').format('YYYY-MM-DD')
              : Date[1];
        } else {
          ArrivalDate = today;
          DepartureDate = dayjs(ArrivalDate).add(1, 'day').format('YYYY-MM-DD');
        }
        HotelWriteOrderParmer = {
          ArrivalDate: ArrivalDate,
          DepartureDate: DepartureDate,
        };
      } else {
        ArrivalDate = today;
        DepartureDate = dayjs(today).add(1, 'day').format('YYYY-MM-DD');
        HotelWriteOrderParmer = {
          ArrivalDate: ArrivalDate,
          DepartureDate: DepartureDate,
        };
      }
      let HotelSearchData = settings.HotelSearchData || {};
      let Date = [ArrivalDate, DepartureDate];
      HotelSearchData = { ...HotelSearchData, Date };

      settings.HotelSearchData = HotelSearchData;
      HotelWriteOrderParmer.CityName = item.arrivalCityName;
      HotelWriteOrderParmer.HotelId = item.mainKey;
      HotelWriteOrderParmer.HotelName = item.productName;
      settings.HotelWriteOrderParmer = HotelWriteOrderParmer;
      app.SetSettings(settings);

      uni.navigateTo({
        url: `/pages/product3.0/hotel/writeOrder/writeOrder?hotelId=${item.mainKey}&bookType=1`,
      });
    },
  },
};
export default checkEnterHotelWriteMinxins;
